//烟酒史
import { OTHER_HISTORY_TYPE, SET_VALUE, GET_OTHER_HISTORY } from "./actionType";

const defaultState = {
  habit: 1,//1从不、2已戒、3仍有
  years: "",//年限
  frequency: "",//频率
};
const Reducer = (state = defaultState, action) => {
  switch (action.type) {
    case OTHER_HISTORY_TYPE://状态
      return { ...state, ...action };
    case SET_VALUE:
      return { ...state, ...action.params };
    case GET_OTHER_HISTORY:
      return { ...state, ...action.values };
    default:
      return state;
  }
};

export default Reducer;
